<div class="d-flex align-items-center d-grid gap-2" [title]="displayName" (click)="downloadAttachment()">
    <i class="fas fa-cloud-arrow-down" style="width: 20px;"></i>
    <span class="text-nowrap text-truncate">{{ displayName }}</span>
</div>